module.exports = __webpack_public_path__ + "static/media/neutral.5e9672eb.png";